import {Component, Event, EventEmitter, h, Prop, Watch} from '@stencil/core';

/**
 * @slot default - Step label
 */
@Component({
    tag: 'joy-step',
    styleUrl: 'style/step.scss',
    shadow: true,
})
export class Step {
    private COMPLETION_OFFSET = 0.1;

    /** Default or small. */
    @Prop() size: 'small' | 'default' = 'default';
    /** Total number of sub steps. Value 1 meens no sub step. */
    @Prop({reflect: true}) subSteps = 1;
    /** @internal If the step is completed. This property is provided by joy-stepper. You don't have to specify it manually. */
    @Prop() completed = false;
    /** @internal Current sub step. This property is provided by joy-stepper. You don't have to specify it manually. */
    @Prop() currentSubStep: number = 0;

    @Event({eventName: 'joy-step-sub-steps-change'}) joyStepSubStepsChange!: EventEmitter<void>;

    async componentWillLoad() {
        this.checkSubSteps();
    }

    @Watch('subSteps')
    private checkSubSteps() {
        if (this.subSteps <= 0) {
            console.warn('subSteps must be equal or greater than 1');
        }

        this.joyStepSubStepsChange.emit();
    }

    get current() {
        return this.currentSubStep > 0;
    }

    get progress() {
        if (this.completed) {
            return 1;
        } else if (this.current) {
            if (this.subSteps <= 1 || this.currentSubStep === 1) {
                return this.COMPLETION_OFFSET;
            }

            return Math.min(this.currentSubStep / this.subSteps - this.COMPLETION_OFFSET, 1 - this.COMPLETION_OFFSET);
        }

        return 0;
    }

    render() {
        return (
            <div
                class={{
                    'joy-step': true,
                    'joy-step--completed': this.completed,
                    'joy-step--ongoing': this.current,
                    [`joy-step--size-${this.size}`]: true,
                }}
            >
                <span class="joy-step__stroke">
                    <span class="joy-step__stroke--filled" style={{maxWidth: `${this.progress * 100}%`}}></span>
                </span>
                <span class="joy-step__label">
                    <slot />
                </span>
            </div>
        );
    }
}
